<template>
  <div>
    <vg-pull-refresh-list v-show="isActive"
                          empty-text="暂无我的申请记录"
                          :onLoadPage="onLoadPagePending"
                          v-slot="{items}"
                          @loaded="items => applications = items"
                          ref="list">
      <digital-pass-application v-for="item in items"
                                :key="item.applicationSituationId"
                                :value="item"/>
    </vg-pull-refresh-list>
    <vg-button-group-fixed>
      <vg-button class="primary" @click="openApplyForInvoicing">申请开票</vg-button>
    </vg-button-group-fixed>
  </div>
</template>
<script>
import defaultPicture from "@/assets/myElectronicPass/defaultPicture.png";
import {client} from "@/libraries/http";
import VgPullRefreshList from "@/components/Commons/VgPullRefreshList.vue";
import VgButton from "@/components/Commons/VgButton.vue";
import VgButtonGroupFixed from "@/components/Commons/VgButtonGroupFixed.vue";
import DigitalPassApplication from "@/views/DigitalPassApplications/DigitalPassApplicationItem.vue";
import useDpApplicationForm from "@/store/dp-application-form-store";
import useAuthnStore from "@/store/authn";

export default {
  name: "DigitalPassApplications",
  components: {
    DigitalPassApplication,
    VgButtonGroupFixed,
    VgButton,
    VgPullRefreshList
  },
  props: {},
  data() {
    return {
      defaultLogo: defaultPicture,
      applicationSituation: undefined,
      isActive: true,
      applications: [],
    };
  },
  computed: {},
  methods: {
    onLoadPagePending({page, size}) {
      return client.get('/api/h5/digital-passes/applications', {
        params: {
          page: page,
          size: size
        }
      }).then(res => {
        this.applicationSituation = res.data.content;
        let records = res.data.content;
        return {
          models: records,
          finished: res.data.last,
        };
      });
    },
    clickApply() {
      //点击申请 跳转申请页面
      useDpApplicationForm().reset()
      this.$router.push({name: 'digital-passes-applications-form'});
    },
    openApplyForInvoicing() {
      // this.$toast("该功能尚未开放，敬请期待。")
      //申请开票
      const authn = useAuthnStore();
      this.$router.push({path: '/applyInvoice', query: {phoneNum: authn.user?.userPhone}});
    },

  },
};
</script>
<style scoped>
.details {
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  margin: 15px;
}

.details >>> .van-cell__value {
  text-align: left;
}

</style>
